import { apiFetch } from "../../../../toolympus/api/core";
import { useAction } from "../../../../toolympus/api/useAction";
import { useEditItem2 } from "../../../../toolympus/api/useNewItem";
import { Department, Employee } from "../types";


export interface HideOrUnhide {
  kind: 'department' | 'employee';
  operation: 'hide' | 'unhide';
  item: {
    _id: string;
    title?: string;      // Used for department
    first_name?: string; // Used for employee
    last_name?: string;  // Used for employee
  };
}

export const useManageOrgStructure = (onChange?: () => void) => {

  const editHidden = useEditItem2<{ employees: Employee[], departments: Department[] }>({
    save: async (item) => {
      return item;
    },
    dontResetOnSave: true,
  });

  const doHideOrUnhide = async (item: HideOrUnhide) => {
    const result = await apiFetch<{}>(`/api/org/structure/${item.kind}/${item.item._id}`, "put", {
      is_hidden: item.operation === "hide",
    });
    if(onChange) {
      onChange();
    }
    if(editHidden.item) {
      if(item.kind === "department" && editHidden.item.departments?.find(x => x._id === item.item._id)) {
        editHidden.update({ departments: editHidden.item.departments.filter(x => x._id !== item.item._id) })
      } else if(item.kind === "employee" && editHidden.item.employees?.find(x => x._id === item.item._id)) {
        editHidden.update({ employees: editHidden.item.employees.filter(x => x._id !== item.item._id) })
      }
    }
    return result;
  }

  const hideOrUnhide = useEditItem2<HideOrUnhide>({
    save: async (item) => {
      await doHideOrUnhide(item);
      return item;
    }
  });


  const startEditHidden = useAction(async () => {
    const departments = await apiFetch<Department[]>(`/api/org/structure/department?include_hidden=true`, "get");
    const employees = await apiFetch<Employee[]>(`/api/org/structure/employee?include_hidden=true`, "get");
    editHidden.startEditing({
      employees: employees.filter(x => x.is_hidden),
      departments: departments.filter(x => x.is_hidden),
    });
  });

  return {
    isLoading: hideOrUnhide.isLoading || startEditHidden.isRunning,
    
    hideOrUnhide,
    doHideOrUnhide,
    editHidden: {
      ...editHidden,
      start: startEditHidden.run,
    },
  }
}

export type ManageOrgStructureData = ReturnType<typeof useManageOrgStructure>;
